import { useEffect } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

import { ProgressBar, Title, SubTitle as SubTitleInner } from './components'
import FooterButton from 'components/modules/common/FooterButton'
import reward from 'images/onboarding_reward.png'

const OnboardingStep1B = () => {
  const history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container>
      <ProgressBarWrapper>
        <ProgressBar currentStep={1} />
      </ProgressBarWrapper>

      <TitleWrapper>
        <Title>
          확실한 보상이 있으면
          <br />
          계속 하게 돼요.
        </Title>
        <SubTitle>
          꾸준히 인증하면
          <br />
          포인트로 다양한 상품을 살 수 있어요
        </SubTitle>
      </TitleWrapper>

      <Content>
        <ImageWrapper>
          <img src={reward} alt={'보상'} />
        </ImageWrapper>
      </Content>

      <FooterButton isValid={true} onComplete={() => history.push('/onboarding/step2')}>
        좋아! 한번 시작해 볼래!
      </FooterButton>
    </Container>
  )
}

const Container = styled.div`
  padding: 24px 20px 36px;
  position: relative;
  height: 100vh;
`

const SubTitle = styled(SubTitleInner)`
  line-height: calc(100vw * (24 / 375));
`

const ProgressBarWrapper = styled.div`
  margin-bottom: 36px;
`

const TitleWrapper = styled.div`
  margin-bottom: 41px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ImageWrapper = styled.div`
  width: calc(100vw * (339 / 375));
`

export default OnboardingStep1B
